<section class="stc-carrito banner-padding">
  <div class="container">
    <div class="row sub-headers-inside sub-inside">

      <div class="col-12 my-auto text-center">
        <div class="overlap-signature header-inside">
          <span class="letter"> <span class="signature-text">Carrito de </span></span>
          <h1 class="main-text">compras</h1>
        </div>
      </div>
    </div>
  </div>
</section>



<section class="stc-boleto">
  <div class="container">
    <div class="row container-info" data-aos="fade-right">

      <div class="col-md-8 offset-md-2 text-center">
        <p>
          <span>
            {{boletos.length}}
          </span>
          Boleto(s) seleccionado(s):
        </p>
      </div>

      <div class="col-12 text-center content-minute "
        [hidden]="st.minutesDisplay == 0 && st.secondsDisplay == 0 || boletos.length == 0 || tipos_pago == 2 || tipos_pago == 3">
        <i class="fa fa-clock-o" aria-hidden="true"></i>

        <span>
          {{(st.minutesDisplay) && (st.minutesDisplay <= 59) ? st.minutesDisplay : '00' }} : {{(st.secondsDisplay) &&
            (st.secondsDisplay <=59) ? (st.secondsDisplay < 10) ? '0' + st.secondsDisplay : st.secondsDisplay : '00' }}
            </span>
      </div>

      <ng-container *ngFor="let boleto of boletos">
        <div class="col-6 text-center">
          <a (click)="deleteBoleto(boleto)">
            <i role="button" class="fa fa-times-circle-o mr-2" aria-hidden="true"></i>
          </a>
          <label>
            No. {{boleto.folio}}
          </label>
        </div>
        <div class="col-6 text-center">
          <label>
            $ {{boleto.costo}} MXN
          </label>
        </div>
        <div class="col-md-12 text-center" *ngIf="boleto.nombre_comprador">
          <label>
            {{boleto.nombre_comprador}}
          </label>

        </div>
      </ng-container>

      <hr class="line w-100">

      <div class="col-6 text-center">
        <label class="txt ">
          Total
        </label>
      </div>

      <div class="col-6 text-center">
        <label class="txt">$ {{total_compra}} MXN</label>
      </div>

      <div class="col-12 text-center" *ngIf="boletos.length == 0">
        <label>No se ha seleccionado ningún boleto.</label>
      </div>

      <div *ngIf="tipos_pago !== 2 && tipos_pago !== 3 && bolCola !== 1 && !flagEgresado && !flagVentaCruzada"
        class="col-12 text-right">
        <button (click)="regresar();" class="btn-stack purple">
          {{ tipos_pago == 3 ? 'Regresar' : 'Agregar otro boleto'}}
        </button>
      </div>
      <div class="col-12 text-right">
        <button [disabled]="boletos.length == 0 || validandoLimite" (click)="efectuarPago();" class="btn-stack">
          Comprar
        </button>
      </div>

    </div>
  </div>
</section>




<section class="spinner">
  <div class="container">
    <div class="row">
      <div class="col-md-12">

        <div class="spinnback" id="spin" [hidden]="spinner">
          <div class="spinn">

            <label>Espere por favor. <br> Procesando </label><br>
            <div class="lds-hourglass"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- pop 
<div class="alert popamigable" role="alert"  id="popupamigable"  [hidden]="true">
	<div class="container">
		<div class="row">
			<div class="col-12">
				<label class="poptext">¡No te vayas!</label><br>
				<label class="poptext">Anímate a participar en el </label><br>
				<label class="poplabel">Sorteo Anáhuac 2023</label>	<br>
				<label class="poptext">Compra los boletos que has elegido y </label><br>
				<label class="text-danger poplabel	">¡Gana excelentes premios!</label>
				<div class="modal-footer center">
					<button id="cerrarpop" type="button" style="place-content: center;" class="btn btn-secondary btn-pop" (click)="PopupAmigable(1)">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</div>

-->

<!-- Cambios Luis Aguilar WECODE -->
<!-- Datos Campaña  pop -->
<!-- <div *ngIf="ShowPopCampania" class="modal" tabindex="-1" role="dialog"> -->
<!-- <div class="modal fade" id="modalCompania" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg"  *ngIf="ShowPopCampania" >
    <div class="modal-content">
      <div class="modal-header text-center">
        <h4 id="dialog-auto-name" class="modal-title pull-left">
			Ya casi tienes tu boleto, para continuar sólo déjanos tu correo electrónico 
        </h4>
      </div>
      <div class="modal-body" >
        <form class="form row" [formGroup]="formDatosCompradorCampania">
          <div class="form-group col-md-12" >
            <div class="col-12 block">
              <label class="control-label" for="correo">Correo electrónico</label>
              <input
                type="email"
                [(ngModel)]="InfoCompradorCampania.correo"
                class="form-control shadow"
                maxlength="50"
                formControlName="correo"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer center">
        <button
          id="registrarDatosCampanias"
          type="button"
          style="place-content: center"
          class="btn btn-pop btn-stack"
          (click)="RegistroDatosCampanias()"
        >
          Continuar
        </button>
 <button id="cerrarpop" type="button" style="place-content: center" class="btn btn-pop btn-stack" (click)="ClosePopCampanias()">
          Cerrar
        </button> 
      </div>
    </div>
  </div>
 </div> -->
<!-- Datos Campaña pop -->

<!-- Modal: boletos bloqueados (SIN SALIDA) -->
<!-- No tiene tache, no cierra al hacer clic afuera y no cierra con ESC: el único
     camino es el botón "Entendido". Aun así, la protección real NO es este modal
     sino que bloqueaCarrito() ya borró localStorage y sessionStorage antes de
     mostrarlo (ver el comentario en el .ts). -->
<div *ngIf="modalBloqueo"
     style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(40,20,10,0.78);z-index:10000;display:flex;align-items:center;justify-content:center;padding:16px;">
  <div style="background:#fff;border-radius:14px;max-width:540px;width:100%;overflow:hidden;box-shadow:0 12px 40px rgba(0,0,0,0.45);border-top:6px solid #ff5900;">

    <!-- Encabezado naranja -->
    <div style="background:linear-gradient(135deg,#ff5900 0%,#fc5705 55%,#eb4d10 100%);padding:26px 24px 22px;text-align:center;">
      <div style="width:58px;height:58px;margin:0 auto 14px;border-radius:50%;background:rgba(255,255,255,0.22);display:flex;align-items:center;justify-content:center;">
        <span style="font-size:2rem;line-height:1;color:#fff;font-weight:bold;">!</span>
      </div>
      <h4 style="margin:0;font-size:1.3rem;color:#fff;font-weight:bold;line-height:1.3;">{{ modalTitulo }}</h4>
    </div>

    <!-- Un renglón por boleto, con su mensaje completo y el folio en negrita -->
    <div style="padding:24px 26px 6px;text-align:left;max-height:46vh;overflow-y:auto;">
      <div *ngFor="let m of modalMensajes"
           style="margin:0 0 12px;padding:12px 14px;background:#fff6f1;border-left:4px solid #ff5900;border-radius:6px;color:#4a4a4a;font-size:0.97rem;line-height:1.5;">
        {{ m.pre }}<strong *ngIf="m.folio" style="font-weight:bold;color:#eb4d10;">{{ m.folio }}</strong>{{ m.post }}
      </div>
    </div>

    <!-- Único camino de salida -->
    <div style="padding:14px 28px 30px;text-align:center;">
      <button type="button"
              style="min-width:200px;font-size:1.02rem;font-weight:bold;padding:13px 30px;color:#fff;background:#ff5900;border:0;border-radius:30px;cursor:pointer;box-shadow:0 4px 14px rgba(255,89,0,0.42);"
              (click)="regresaHome()">
        Entendido
      </button>
      <p style="margin:16px 0 0;font-size:0.9rem;color:#666;">Puedes elegir otro boleto y seguir con tu compra.</p>
    </div>

  </div>
</div>

<!-- Modal: límite máximo por transacción (se cierra; el usuario puede quitar boletos) -->
<div *ngIf="modalLimite"
     style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(40,20,10,0.78);z-index:10000;display:flex;align-items:center;justify-content:center;padding:16px;">
  <div style="background:#fff;border-radius:14px;max-width:540px;width:100%;overflow:hidden;box-shadow:0 12px 40px rgba(0,0,0,0.45);border-top:6px solid #ff5900;">
    <div style="background:linear-gradient(135deg,#ff5900 0%,#fc5705 55%,#eb4d10 100%);padding:26px 24px 22px;text-align:center;">
      <div style="width:58px;height:58px;margin:0 auto 14px;border-radius:50%;background:rgba(255,255,255,0.22);display:flex;align-items:center;justify-content:center;">
        <span style="font-size:2rem;line-height:1;color:#fff;font-weight:bold;">!</span>
      </div>
      <h4 style="margin:0;font-size:1.3rem;color:#fff;font-weight:bold;line-height:1.3;">Límite máximo por transacción</h4>
    </div>
    <div style="padding:24px 26px 6px;text-align:left;">
      <div style="margin:0 0 12px;padding:12px 14px;background:#fff6f1;border-left:4px solid #ff5900;border-radius:6px;color:#4a4a4a;font-size:0.97rem;line-height:1.5;">
        El monto máximo por transacción es de <strong style="color:#eb4d10;">{{ limiteMontoMaximo | currency:'MXN':'symbol-narrow':'1.0-0' }}</strong>.
        Este total incluye todos los boletos de tu carrito.
      </div>
    </div>
    <div style="padding:14px 28px 30px;text-align:center;">
      <button type="button"
              style="min-width:200px;font-size:1.02rem;font-weight:bold;padding:13px 30px;color:#fff;background:#ff5900;border:0;border-radius:30px;cursor:pointer;box-shadow:0 4px 14px rgba(255,89,0,0.42);"
              (click)="modalLimite = false">
        Entendido
      </button>
      <p style="margin:16px 0 0;font-size:0.9rem;color:#666;">Quita boletos de tu carrito para continuar con tu compra.</p>
    </div>
  </div>
</div>

<!-- Modal: ¿Sigues ahí? -->
<div *ngIf="st.showWarningModal"
     style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.65);z-index:9999;display:flex;align-items:center;justify-content:center;">
  <div style="background:#fff;border-radius:10px;padding:36px 32px;max-width:420px;width:90%;text-align:center;box-shadow:0 6px 32px rgba(0,0,0,0.35);">
    <h4 style="margin-bottom:12px;font-size:1.4rem;">¿Sigues ahí?</h4>
    <p style="margin-bottom:8px;color:#555;">Tu sesión está por expirar. ¿Deseas continuar con tu compra?</p>
    <p style="font-size:2.5rem;font-weight:bold;margin-bottom:24px;color:#c0392b;">{{ st.modalCountdown }}</p>
    <button class="btn btn-primary" style="min-width:160px;font-size:1rem;padding:10px 24px;" (click)="st.continuarSesion()">
      Sigo aquí
    </button>
  </div>
</div>
<!-- END Cambios Luis Aguilar WECODE -->